import { createContext, RefObject } from 'react';
import { StepState } from '@salvapp/ui-components/build/SalvProgressStepper/SalvProgressStepper.types';
import { FormikErrors, FormikProps } from 'formik';

interface ProgressStepperType {
  steps: StepState[];
  activeStep?: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
  setGeneralSetupStep: (step: Partial<StepState>) => void;
  setScreeningSetupStep: (step: Partial<StepState>) => void;
  setMonitoringSetupStep: (step: Partial<StepState>) => void;
}

export type AlertType = {
  isScreeningEnabled: boolean;
  isMonitoringEnabled: boolean;
  isBridgeEnabled: boolean;
  isManualEnabled: boolean;
};

export interface GeneralSetupDataType {
  name: string;
  code: string;
  isFinal: boolean;
  isTruePositive: boolean | null;
  alertType: AlertType;
  entityType: {
    isPerson: boolean;
    isTransaction: boolean;
  };
}

export interface ScreeningSetupDataType {
  alertSubtype: {
    isPep: boolean;
    isSanctions: boolean;
    isAdverseMedia: boolean;
    isAdverseMediaEntities: boolean;
    customLists: {
      id: string;
      name: string;
      isEnabled: boolean;
    }[];
  };
  isGoodlistable: boolean;
}

export interface MonitoringSetupDataType {
  alertSubtype: {
    isOnline: boolean;
    isOffline: boolean;
    isPeriodic: boolean;
  };
}

const AlertStatusSetupContext = createContext<{
  progressStepper: ProgressStepperType;
  formRef: RefObject<FormikProps<any> | null>;
  setAlertType: (value: AlertType) => void;
  generalSetup: {
    data: GeneralSetupDataType;
    setData: (value: GeneralSetupDataType) => void;
    isValid: boolean;
    setValid: (value: boolean) => void;
    isSubmissionTouched: boolean;
    isSubmitted: boolean;
    setSubmitted: (value: boolean) => void;
  };
  screeningSetup: {
    data: ScreeningSetupDataType;
    setData: (value: ScreeningSetupDataType) => void;
    isValid: boolean;
    setValid: (value: boolean) => void;
    isSubmissionTouched: boolean;
    isSubmitted: boolean;
    setSubmitted: (value: boolean) => void;
  };
  monitoringSetup: {
    data: MonitoringSetupDataType;
    setData: (value: MonitoringSetupDataType) => void;
    isValid: boolean;
    setValid: (value: boolean) => void;
    isSubmissionTouched: boolean;
    isSubmitted: boolean;
    setSubmitted: (value: boolean) => void;
  };
  apiErrors: FormikErrors<any>;
} | null>(null);

export default AlertStatusSetupContext;
